import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import AtivoEdit from './pages/AtivoEdit';
import AtivoFavoritesListContainer from './pages/AtivoFavoritesListContainer';
import AtivoListContainer from './pages/AtivoListContainer';
import AtivoRepresentanteListContainer from './pages/AtivoRepresentanteListContainer';
import AtivosMedicoListContainer from './pages/AtivosMedicoListContainer';
import AtivosPendentesListContainer from './pages/AtivosPendentesListContainer';
import BuildUserProfileContainer from './pages/BuildUserProfileContainer';
import ConditionalRoleBasedRoute from './components/ConditionalRoleBasedRoute';
import EspecialidadeEdit from './pages/EspecialidadeEdit';
import EspecialidadesContainer from './pages/EspecialidadesContainer';
import FormulaEdit from './pages/FormulaEdit';
import FormulaFavoritesListContainer from './pages/FormulaFavoritesListContainer';
import FormulaListContainer from './pages/FormulaListContainer';
import FormulaMedicoEdit from './pages/FormulaMedicoEdit';
import FormulasMedicoListContainer from './pages/FormulaMedicoListContainer';
import FormulasPendentesListContainer from './pages/FormulasPendentesListContainer';
import FormulasRepresentanteListContainer from './pages/FormulaRepresentanteListContainer';
import Home from './pages/Home';
import LinkAtivoFormulas from './pages/LinkAtivoFormulas';
import LinkAtivoVeiculo from './pages/LinkAtivoVeiculo';
import LinkEspecialidadeToMedicamentosContainer from './pages/LinkEspecialidadeToMedicamentosContainer';
import LinkEspecialidadeToMedicoContainer from './pages/LinkEspecialidadeToMedicoContainer';
import LinkFormulaAtivos from './pages/LinkFormulaAtivos';
import LinkMedicamentoToMedicoContainer from './pages/LinkMedicamentosToMedicoContainer';
import LinkMedicoRepresentanteContainer from './pages/LinkMedicoRepresentanteContainer';
import Login from './pages/Login';
import MedicamentoEdit from './pages/MedicamentoEdit';
import MedicamentoFavoritesListContainer from './pages/MedicamentoFavoritesListContainer';
import MedicamentoListContainer from './pages/MedicamentoListContainer';
import MedicamentoLogsListContainer from './pages/MedicamentoLogsListContainer';
import MedicamentoLogsMedicoListContainer from './pages/MedicamentoLogsMedicoListContainer';
import MedicamentoLogsRepresentanteListContainer from './pages/MedicamentoLogsRepresentanteListContainer';
import MedicamentoMedicoListContainer from './pages/MedicamentoMedicoListContainer';
import MedicamentoRepresentanteListContainer from './pages/MedicamentorepresentanteListContainer';
import MedicamentosPendentesListContainer from './pages/MedicamentosPendentesListContainer';
import ModeloReceitaEdit from './pages/ModeloReceitaEdit';
import Navbar from './layout/Navbar';
import NewAtivoForm from './pages/NewAtivoForm';
import NewEspecialidadeForm from './pages/NewEspecialidadeForm';
import NewFormulaForm from './pages/NewFormulaForm';
import NewMedicamentoForm from './pages/NewMedicamentoForm';
import NewPassword from './pages/NewPassword';
import NewReceitaForm from './pages/NewReceitaForm';
import NewReceitaModeloForm from './pages/NewReceitaModeloForm';
import NewUnidadeForm from './pages/NewUnidadeForm';
import NewUsuarioForm from './pages/NewUsuarioForm';
import NewVeiculoUtilizacaoForm from './pages/NewVeiculoUtilizacaoForm';
import PasswordRecovery from './pages/PasswordRecovery';
import PrivateRoute from './components/PrivateRoute';
import React from 'react';
import ReceitaContainer from './pages/ReceitaContainer';
import ReceitaContainerNew from './pages/ReceitaContainerNew';
import ReceitaListContainer from './pages/ReceitaListContainer';
import ReceitaMedicoListContainer from './pages/ReceitaMedicoListContainer';
import ReceitaModeloListContainer from './pages/ReceitaModeloListContainer';
import ReceitaModeloRepresentanteListContainer from './pages/ReceitaModeloRepresentanteListContainer';
import ReceitaPage from './pages/ReceitaPage';
import ReceitaRepresentanteListContainer from './pages/ReceitaRepresentanteListContainer';
import ResultListPage from './pages/ResultListPage';
import RoleBasedRoute from './components/RoleBasedRoute';
import UnidadeEdit from './pages/UnidadeEdit';
import UnidadeListContainer from './pages/UnidadeListContainer';
import UsuarioEdit from './pages/UsuarioEdit';
import UsuarioListContainer from './pages/UsuarioListContainer';
import VeiculoUtilizacaoEdit from './pages/VeiculoUtilizacaoEdit';
import VeiculoUtilizacaoListContainer from './pages/VeiculoUtilizacaoListContainer';

// Components

export default function Routes() {
  return (
    <BrowserRouter>
      <Navbar />

      <div className='container'>
        <Switch>
          <PrivateRoute exact path='/' component={Home} />
          <PrivateRoute path='/home' component={Home} />
          <Route path='/login' component={Login} />

          <Route exact path='/search' component={ResultListPage} />

          <RoleBasedRoute
            exact
            path='/usuarios'
            component={UsuarioListContainer}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/usuarios/new'
            component={NewUsuarioForm}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/usuarios/:id/edit'
            component={UsuarioEdit}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/usuarios/:id/montar_perfil'
            component={BuildUserProfileContainer}
            roles={['G']}
          />
          <PrivateRoute
            path='/usuarios/:id/newPassword'
            component={NewPassword}
          />

          <ConditionalRoleBasedRoute
            exact
            path='/ativos'
            conditions={[
              { role: 'G', component: AtivoListContainer },
              { role: 'R', component: AtivoRepresentanteListContainer },
              { role: 'M', component: AtivosMedicoListContainer },
            ]}
          />
          <RoleBasedRoute
            path='/ativos/pendentes'
            component={AtivosPendentesListContainer}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/ativos/new'
            component={NewAtivoForm}
            roles={['G', 'M', 'R']}
          />
          <RoleBasedRoute
            path='/ativos/:id/edit'
            component={AtivoEdit}
            roles={['G', 'M']}
          />
          <RoleBasedRoute
            path='/ativos/:id/link/veiculosUtilizacao'
            component={LinkAtivoVeiculo}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/ativos/:id/link/formulas'
            component={LinkAtivoFormulas}
            roles={['G']}
          />

          <RoleBasedRoute
            exact
            path='/veiculosUtilizacao'
            component={VeiculoUtilizacaoListContainer}
            roles={['G', 'R']}
          />
          <RoleBasedRoute
            path='/veiculosUtilizacao/new'
            component={NewVeiculoUtilizacaoForm}
            roles={['G', 'R']}
          />
          <RoleBasedRoute
            path='/veiculosUtilizacao/:id/edit'
            component={VeiculoUtilizacaoEdit}
            roles={['G', 'R']}
          />

          <ConditionalRoleBasedRoute
            exact
            path='/formulas'
            conditions={[
              { role: 'G', component: FormulaListContainer },
              { role: 'R', component: FormulasRepresentanteListContainer },
              { role: 'M', component: FormulasMedicoListContainer },
            ]}
          />
          <RoleBasedRoute
            path='/formulas/pendentes'
            component={FormulasPendentesListContainer}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/formulas/new'
            component={NewFormulaForm}
            roles={['G', 'R', 'M']}
          />
          <RoleBasedRoute
            path='/formulas/:id/edit'
            component={FormulaEdit}
            roles={['G', 'M']}
          />
          <RoleBasedRoute
            path='/formulas/:id/link/ativos'
            component={LinkFormulaAtivos}
            roles={['G', 'M']}
          />

          <ConditionalRoleBasedRoute
            exact
            path='/medicamentos'
            conditions={[
              { role: 'G', component: MedicamentoListContainer },
              { role: 'R', component: MedicamentoRepresentanteListContainer },
              { role: 'M', component: MedicamentoMedicoListContainer },
            ]}
          />
          <RoleBasedRoute
            path='/medicamentos/pendentes'
            component={MedicamentosPendentesListContainer}
            roles={['G', 'R']}
          />
          <RoleBasedRoute
            path='/medicamentos/new'
            component={NewMedicamentoForm}
            roles={['G', 'M', 'R']}
          />
          <RoleBasedRoute
            path='/medicamentos/:id/edit'
            component={MedicamentoEdit}
            roles={['G', 'M', 'R']}
          />

          <Route path='/passwordRecovery' component={PasswordRecovery} />

          <RoleBasedRoute
            path='/m/formulas/:formulaId/edit'
            component={FormulaMedicoEdit}
            roles={['M']}
          />

          <RoleBasedRoute
            path='/medicos/:medicoId/ativos/favoritos'
            component={AtivoFavoritesListContainer}
            roles={['M']}
          />
          <RoleBasedRoute
            path='/medicos/:medicoId/formulas/favoritos'
            component={FormulaFavoritesListContainer}
            roles={['M']}
          />
          <RoleBasedRoute
            path='/medicos/:medicoId/industrializados/favoritos'
            component={MedicamentoFavoritesListContainer}
            roles={['M']}
          />
          <RoleBasedRoute
            path='/medicos/:medicoId/receitas'
            component={ReceitaListContainer}
            roles={['G', 'M']}
          />

          <RoleBasedRoute
            exact
            path='/medicamentos/link'
            component={LinkMedicamentoToMedicoContainer}
            roles={['G', 'R']}
          />

          <RoleBasedRoute
            exact
            path='/receita'
            component={ReceitaContainer}
            roles={['M']}
          />
          <RoleBasedRoute
            path='/receita/new'
            component={NewReceitaForm}
            roles={['M']}
          />

          <RoleBasedRoute
            path='/receita/manual'
            component={ReceitaContainerNew}
            roles={['M']}
          />

          <RoleBasedRoute
            exact
            path='/unidades'
            component={UnidadeListContainer}
            roles={['G', 'R']}
          />
          <RoleBasedRoute
            path='/unidades/new'
            component={NewUnidadeForm}
            roles={['G', 'R']}
          />
          <RoleBasedRoute
            path='/unidades/:id/edit'
            component={UnidadeEdit}
            roles={['G', 'R']}
          />

          <ConditionalRoleBasedRoute
            exact
            path='/receitas'
            conditions={[
              { role: 'G', component: ReceitaListContainer },
              { role: 'R', component: ReceitaRepresentanteListContainer },
            ]}
          />
          <RoleBasedRoute
            path='/receitas/:receitaId'
            component={ReceitaPage}
            roles={['G', 'M', 'R']}
          />

          <ConditionalRoleBasedRoute
            exact
            path='/modelos_receita'
            conditions={[
              { role: 'G', component: ReceitaModeloListContainer },
              { role: 'R', component: ReceitaModeloRepresentanteListContainer },
            ]}
          />
          <RoleBasedRoute
            path='/modelos_receita/new'
            component={NewReceitaModeloForm}
            roles={['G', 'R']}
          />
          <RoleBasedRoute
            path='/modelos_receita/:id/edit'
            component={ModeloReceitaEdit}
            roles={['G', 'R']}
          />

          <RoleBasedRoute
            path='/representantes/vincular_medicos'
            component={LinkMedicoRepresentanteContainer}
            roles={['G']}
          />

          <ConditionalRoleBasedRoute
            path='/medicamentos/logs'
            conditions={[
              { role: 'G', component: MedicamentoLogsListContainer },
              { role: 'M', component: MedicamentoLogsMedicoListContainer },
              {
                role: 'R',
                component: MedicamentoLogsRepresentanteListContainer,
              },
            ]}
          />

          <RoleBasedRoute
            exact
            path='/especialidades'
            component={EspecialidadesContainer}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/especialidades/new'
            component={NewEspecialidadeForm}
            roles={['G']}
          />
          <RoleBasedRoute
            path='/especialidades/:id/edit'
            component={EspecialidadeEdit}
            roles={['G']}
          />

          <RoleBasedRoute
            path='/especialidades/medicos/link'
            component={LinkEspecialidadeToMedicoContainer}
            roles={['G']}
          />

          <RoleBasedRoute
            path='/especialidades/medicamentos/link'
            component={LinkEspecialidadeToMedicamentosContainer}
            roles={['G']}
          />
          <Redirect to='/' />
        </Switch>
      </div>
    </BrowserRouter>
  );
}
